<template>
  <div class="main-container">
    <Header v-if="!isAuthRoute" />
    <div class="content">
      <router-view />
    </div>
    <Footer v-if="!isAuthRoute" />
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { computed } from "vue";
import Header from "@/modules/common/components/HeaderComponent.vue";
import Footer from "@/modules/common/components/FooterComponent.vue";

export default {
  components: {
    Header,
    Footer,
  },
  setup() {
    const route = useRoute();
    const authRoutes = ["login", "register", "forgot-password", "NotFound"];

    const isAuthRoute = computed(() => authRoutes.includes(route.name));

    return {
      isAuthRoute,
    };
  },
};
</script>
